import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import MakeAPICall from "../../apiCalls/common";

import { verifyLinkApiRoute, updatePasswordApiRoute } from "../../apiRoutes";
import appRoutes from "../../routes/appRoutes";

import PublicLayout from "../../containers/Layout/PublicLayout";
import PasswordForm from "../../containers/PasswordForm";
import InvalidTokenBox from "../../components/invalidTokenBox";
import CustomModal from "../../components/modal";

import LogoImg from "../../assets/images/group-3@3x.png";

const ResetPasswordPage = props => {
  let history = useHistory();

  const [errorMsg, setErrorMsg] = useState("");
  const [linkToken, setLinkToken] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [showInvalidTokenBox, setInvalidTokenStatus] = useState(false);
  const [showSuccessModal, setSuccessModalState] = useState(false);

  // run only once when component will load
  useEffect(() => {
    async function verifyLink() {
      let urlGot = document.URL;
      let access_token = urlGot.split("token=")[1];
      if (access_token) {
        var finalAccesstoken = access_token.split("&")[0];

        await setApiCallParams({
          reqType: "GET",
          reqUrl: verifyLinkApiRoute + finalAccesstoken,
          dataObj: {},
          successCallback: res => {
            setLinkToken(finalAccesstoken);
          },
          failureCallback: err => {
            setInvalidTokenStatus(true);
          }
        });
      } else {
        setInvalidTokenStatus(true);
      }
    }

    verifyLink();
  }, []);

  const onFormSubmit = async formValues => {
    setIsProcessing(true);

    await setApiCallParams({
      reqType: "PUT",
      reqUrl: updatePasswordApiRoute,
      dataObj: {
        token: linkToken,
        password: formValues.newPassword
      },
      successCallback: res => {
        setSuccessModalState(true);
        setIsProcessing(false);
      },
      failureCallback: err => {
        //setErrorMsg(err.message);
        setIsProcessing(false);
      }
    });
  };

  const goToLoginPage = () => {
    history.push(appRoutes.login);
  };

  return (
    <PublicLayout>
      <div className="login-page-container container d-flex align-items-center justify-content-center">
        <CustomModal
          cancelText="OKAY"
          openModal={showSuccessModal}
          cancelEvent={goToLoginPage}
          modalBodyContent={
            <p className="text-center mb-0">
              New Password Created Successfully <br />
              Please Login
            </p>
          }
          useOneButton={true}
        />
        {!showInvalidTokenBox && (
          <div className="lg-page-inner-container">
            <div className="lp-header row">
              <div className="col-md-12">Create Password</div>
            </div>
            <div className="row lp-content-container d-flex justify-content-center align-items-center">
              <div className="col-md-12 logo-img-container d-flex justify-content-center align-items-center">
                <img src={LogoImg} alt="logo-img" />
              </div>
              <div className="col-md-12 d-flex justify-content-center align-items-center lg-form-container">
                <PasswordForm
                  onFormSubmit={onFormSubmit}
                  serverErrorMsg={errorMsg}
                  isProcessing={isProcessing}
                />
              </div>
            </div>
          </div>
        )}
        {showInvalidTokenBox && <InvalidTokenBox />}
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </PublicLayout>
  );
};

export default ResetPasswordPage;
